/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterGroup } from '../../models/work-center-group';

export interface GetWorkCenterGroup$Params {
  workCenterGroupId: number;
}

export function getWorkCenterGroup(http: HttpClient, rootUrl: string, params: GetWorkCenterGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkCenterGroup>> {
  const rb = new RequestBuilder(rootUrl, getWorkCenterGroup.PATH, 'get');
  if (params) {
    rb.path('workCenterGroupId', params.workCenterGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkCenterGroup>;
    })
  );
}

getWorkCenterGroup.PATH = '/api/v1/WorkCenterGroup/{workCenterGroupId}';
